// Carry Roll Probability helper — normal-CDF lateral finish (emergent). Pure.
// No new dependency: uses the Abramowitz-Stegun erf approximation.
const SQRT2 = Math.SQRT2;
/**
 * Error function via the Abramowitz-Stegun 7.1.26 approximation (max error ~1.5e-7).
 */
export function erf(x) {
    const sign = x < 0 ? -1 : 1;
    const ax = Math.abs(x);
    const p = 0.3275911;
    const a1 = 0.254829592;
    const a2 = -0.284496736;
    const a3 = 1.421413741;
    const a4 = -1.453152027;
    const a5 = 1.061405429;
    const t = 1 / (1 + p * ax);
    const y = 1 - ((((a5 * t + a4) * t + a3) * t + a2) * t + a1) * t * Math.exp(-ax * ax);
    return sign * y;
}
/**
 * Probability that a normally-distributed lateral finish (std dev `spreadM`,
 * mean centred on target) lands within `±halfWidthM`.
 * P(|X| ≤ halfWidthM) = erf(halfWidthM / (spreadM * √2)).
 */
export function pWithinHalfWidth(spreadM, halfWidthM) {
    if (spreadM <= 0)
        return halfWidthM >= 0 ? 1 : 0;
    return erf(halfWidthM / (spreadM * SQRT2));
}
//# sourceMappingURL=probability.js.map